var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVcUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.426,
    height: 35.774,
    viewBox: "0 0 27.426 35.774",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "user",
    transform: "translate(-7.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_32048",
    "data-name": "Path 32048",
    d: "M32.214,25.92l-5.427-3.528,2.046-3.751a5.979,5.979,0,0,0,.728-2.855V9.847a8.347,8.347,0,1,0-16.694,0v5.938a5.98,5.98,0,0,0,.728,2.855l2.046,3.751L10.213,25.92a5.942,5.942,0,0,0-2.713,5v6.355H34.926V30.919A5.942,5.942,0,0,0,32.214,25.92Zm.328,8.969H9.885v-3.97a3.565,3.565,0,0,1,1.628-3l7.278-4.731-3.1-5.69a3.588,3.588,0,0,1-.437-1.713V9.847a5.962,5.962,0,0,1,11.925,0v5.938a3.588,3.588,0,0,1-.437,1.713l-3.1,5.69,7.279,4.731a3.565,3.565,0,0,1,1.628,3Z",
    fill: "#6b6b6b"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVcUser);
export default __webpack_public_path__ + "static/media/vc-user.7b3555fcd4b14a845461f90dcd6725f1.svg";
export { ForwardRef as ReactComponent };